<template>
  <div class="mobileLayout">
    <div class="header">
      <div class="itemTitle">
        {{ type === "ADD" ? "添加" : "编辑" }}产品信息
      </div>
      <i class="el-icon-close" @click="closeProductEntry" />
    </div>
    <div class="form">
      <div class="XHForm">
        <div class="XHFormLabel"><span>*</span>产品所属</div>
        <div class="XHFormItem">
          <div class="selector">
            <el-select
              class="select"
              v-model="product.industryType"
              placeholder="行业"
              @change="product.subIndustryType = ''"
            >
              <el-option
                v-for="item in IndustryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              class="select"
              v-model="product.subIndustryType"
              placeholder="品类"
            >
              <el-option
                v-for="item in subIndustryList[product.industryType]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="XHForm">
        <div class="XHFormLabel"><span>*</span>产品名称</div>
        <div class="XHFormItem">
          <el-input
            style="width: 100%"
            v-model="productName"
            placeholder="请输入产品名称"
          />
        </div>
      </div>

      <div class="XHForm" style="height: auto; margin-bottom: 16px">
        <div class="XHFormLabel"><span>*</span>产品卖点</div>
        <div class="XHFormItem" style="height: auto">
          <el-input
            v-model="product.sellingPoint"
            type="textarea"
            :rows="3"
            placeholder="请输入产品卖点，请以“,”或换行符分隔产品卖点"
          ></el-input>
        </div>
      </div>

      <div class="XHForm">
        <div class="XHFormLabel"><span>*</span>目标人群</div>
        <div class="XHFormItem">
          <el-select
            style="display: block"
            v-model="targetAudience"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请输入或选择目标推广人群"
          >
            <el-option
              v-for="item in targetAudienceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="XHForm">
        <div class="XHFormLabel">
          上传更多产品资料
          <span class="grayText">（ 即将上线，敬请期待 ）</span>
        </div>
      </div>
      <div class="buttonWrap">
        <el-button
          v-if="type !== 'ADD'"
          class="button outline"
          @click="askDeleteProduct(editProduct)"
        >
          <span class="deleteButton">删除信息</span>
        </el-button>
        <el-button
          class="button"
          :disabled="
            !product.industryType ||
            !product.subIndustryType ||
            !productName ||
            targetAudience.length === 0 ||
            !product.sellingPoint
          "
          @click="addProductFun"
        >
          保存信息
        </el-button>
      </div>
    </div>
    <el-dialog
      title="提示"
      center
      :visible.sync="visible"
      v-if="deleteItem"
      :modal="false"
      width="300px"
      :before-close="handleClose"
    >
      <span
        style="text-align: center; width: 100%; display: block; color: #111d3a"
      >
        是否确认删除当前产品信息
      </span>
      <div class="buttonGroup">
        <img src="../../assets/statics/confirm.png" @click="deleteProductFun" />
        <img src="../../assets/statics/wait.png" @click="deleteItem = null" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  IndustryList,
  subIndustryList,
  targetAudienceList,
} from "../../utils/constants";
export default {
  data() {
    return {
      product: {
        industryType: this.editProduct.industryType
          ? this.editProduct.industryType
          : "",
        subIndustryType: this.editProduct.subIndustryType
          ? this.editProduct.subIndustryType
          : "",
        sellingPoint: this.editProduct.sellingPoint
          ? this.editProduct.sellingPoint
          : "",
      },
      productName: this.editProduct.productName
        ? this.editProduct.productName
        : "",
      IndustryList,
      subIndustryList,
      targetAudienceList,
      targetAudience: this.editProduct.targetAudience
        ? this.editProduct.targetAudience
        : [],
      deleteItem: null,
    };
  },
  props: {
    addProduct: {
      type: Function,
      required: true,
      default: null,
    },
    deleteProduct: {
      type: Function,
      default: null,
    },
    type: {
      type: String,
      required: true,
      default: "ADD",
    },
    editProduct: {
      type: Object,
      default: {},
    },
    closeProductEntry: {
      type: Function,
      required: true,
      default: null,
    },
  },
  computed: {
    userId() {
      return this.$store.state.user.id;
    },
    visible() {
      return Boolean(this.deleteItem);
    },
  },
  methods: {
    handleClose() {
      this.deleteItem = null;
    },
    askDeleteProduct(item) {
      this.deleteItem = item;
    },
    addProductFun() {
      const params = {
        industry: this.product.industryType,
        subIndustry: this.product.subIndustryType,
        productName: this.productName,
        targetAudience: this.targetAudience.join(","),
        sellingPoint: this.product.sellingPoint,
        userId: this.userId,
      };
      this.addProduct(params, this.editProduct.id);
    },
    deleteProductFun() {
      this.deleteProduct(this.deleteItem);
    },
  },
};
</script>
<style lang="less" scoped>
.mobileLayout {
  padding: 16px 20px;
  z-index: 1000;
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .itemTitle {
    color: #111d3a;
    font-weight: bold;
  }

  .form {
    > :first-child {
      margin-top: 16px;
    }
    > :not(:first-child) {
      margin-top: 12px;
    }
  }

  .XHForm {
    .XHFormLabel {
      margin-bottom: 12px;
      font-weight: 500;
      span {
        color: red;
        margin-right: 4px;

        &.grayText {
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
    .selector {
      display: flex;
      gap: 12px;
      .select {
        flex: 1;
      }
    }
  }
  .buttonWrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .button {
    margin-top: 12px;
    border-radius: 1.5rem;
    height: 3rem;
    flex: 1;
    background: linear-gradient(150deg, #7ba0ff, #ee74ff);
    color: #ffffff;
    position: relative;
    overflow: hidden;

    &.outline {
      color: #a78fff;
      > :first-child::before {
        background: #fff;
        content: " ";
        display: block;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        top: 1px;
        left: 1px;
        position: absolute;
        border-radius: 24px;
      }
    }

    .deleteButton {
      z-index: 2;
      position: relative;
    }
  }
  /deep/ .button.is-disabled {
    background: linear-gradient(150deg, #a8c1ff, #f3c5fa);
  }

  .buttonGroup {
    display: flex;
    margin-top: 24px;
    justify-content: center;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobileChat/AddProduct.vue